import { QueryKeys } from '../../utils/queryKeys';

export const translationKeys = {
    all: [QueryKeys.TRANSLATION],
    getTranslatedTextKeys: (id) => [...translationKeys.all , id],
};